import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: undefined, // optional Mã tự sinh
    ho_ten: // required Tên người dùng
    {
        ten: undefined, // optional Tên
        ho: undefined, // optional Họ
        ho_ten: undefined, // required Họ tên đầy đủ
        dinh_dang: undefined, // optional, enum(hoten, tenho) Định dạng tên
    },
    email: undefined, // optional Email
    dien_thoai: undefined, // optional Số điện thoại
    gioi_tinh: undefined, // optional, min: 1, max: 4 Giới tính: 1 - Nữ, 2 - Nam, 3 - Chưa có thông tin, 4 - Khác
    ngay_sinh: // optional Ngày tháng năm sinh
    {
        ngay: undefined, // optional, min: 1, max: 31 Ngày
        thang: undefined, // optional, min: 1, max: 12 Tháng
        nam: undefined, // optional Năm
        ngay_sinh: undefined, // optional Ngày sinh
    },

    giay_to: // optional Giấy tờ, ví dụ: CMT, CCCD, Họ chiếu
        [{
        loai_giay_to: undefined, // required, enum(CMT, CCCD, PASSPORT) Loại giấy tờ
        so_giay_to: undefined, // required Số giấy tờ
        noi_cap: undefined, // optional Nơi cấp
        ngay_cap: undefined, // optional Ngày cấp
        ngay_het_han: undefined, // optional Ngày hết hạn
    }],

    dia_chi: // optional Địa chỉ
    {
        province_id: undefined, // optional Mã tỉnh/TP
        province_name: undefined, // optional Tên tỉnh/TP
        dia_chi: undefined, // required Địa chỉ đầy đủ
    }

}
model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {}
};

export default model;